import _ from 'lodash';
import React from 'react';

export const getTenderType = ({ type }) => {
  if (_.isNil(type)) {
    type = '—';
  }

  return type;
};

export const getTenderCode = ({ code, id }) => {
  if (!_.isNil(code)) {
    return code;
  }

  return `T${_.padStart(id, 4, 0)}`;
};

export const getTenderRegion = tender => _.get(tender, 'region.name', 'Global');

export const getTenderLifecycle = tender =>
  tender.lifecycle_stages.map((item, index) => (
    <span key={`tender-lifecycle-${index}`}>{_.get(item, 'label')}</span>
  ));

export const getTenderResponseStatus = tender =>
  _.get(tender, 'response_status.label');

export const getTenderTimeEstimate = tender =>
  _.isNil(tender.time_estimate) ? '—' : `${tender.time_estimate} minutes`;
